<div
  class="d-flex align-items-center"
  [class.justify-content-center]="centerText"
>
  @if (showIcon && icon?.placement === 'left' && icon?.name) {
    <fa-icon
      [icon]="icon?.name | scIcon"
      size="2x"
      [ngClass]="[icon?.color, 'me-1']"
    ></fa-icon>
  }
  @if (heading?.text?.value) {
    @if (heading?.tag === 'h1') {
      <h1
        *scText="heading?.text"
        [ngClass]="[heading?.style, heading?.size ?? size, 'mb-0']"
        [class.text-center]="centerText"
      ></h1>
    }
    @if (heading?.tag === 'h2') {
      <h2
        *scText="heading?.text"
        [ngClass]="[heading?.style, heading?.size ?? size, 'mb-0']"
        [class.text-center]="centerText"
      ></h2>
    }
    @if (heading?.tag === 'h3') {
      <h3
        *scText="heading?.text"
        [ngClass]="[heading?.style, heading?.size ?? size, 'mb-0']"
        [class.text-center]="centerText"
      ></h3>
    }
    @if (heading?.tag === 'h4') {
      <h4
        *scText="heading?.text"
        [ngClass]="[heading?.style, heading?.size ?? size, 'mb-0']"
        [class.text-center]="centerText"
      ></h4>
    }
    @if (heading?.tag === 'h5') {
      <h5
        *scText="heading?.text"
        [ngClass]="[heading?.style, heading?.size ?? size, 'mb-0']"
        [class.text-center]="centerText"
      ></h5>
    }
    @if (heading?.tag === 'h6') {
      <h6
        *scText="heading?.text"
        [ngClass]="[heading?.style, heading?.size ?? size, 'mb-0']"
        [class.text-center]="centerText"
      ></h6>
    }
  }
  @if (showIcon && icon?.placement === 'right' && icon?.name) {
    <fa-icon
      [icon]="icon?.name | scIcon"
      size="2x"
      [ngClass]="[icon?.color, 'ms-1']"
    ></fa-icon>
  }
</div>
